import { Button, Typography } from '@intentsify/ui';
import { Component, PropsWithChildren } from 'react';

/**
 * Error boundary for the new user facing apps
 * Does not depend on app store, types barrel, or other heavy imports
 */
export class ErrorBoundary extends Component<
  PropsWithChildren,
  { error: Error | undefined }
> {
  constructor(props: PropsWithChildren) {
    super(props);
    this.state = { error: undefined };
  }

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  render() {
    if (this.state.error) {
      return (
        <div className="flex p-1 flex-col justify-center items-center h-screen gap-5">
          <Typography variant="h1">Error</Typography>
          <Typography variant="h3">
            Something went wrong. Please try again.
          </Typography>
          <Button onClick={() => window.location.reload()}>Reload Page</Button>
        </div>
      );
    }

    return this.props.children;
  }
}
